import React from 'react'

function TableRowSubMenu({ children }) {
  return (
    <div className='bg-white px-4 py-4 rounded absolute transform translate-y-10 -translate-x-4 bottom-12 right-2 z-50 mr-1.5 text-sm text-gray-600 shadow'>
      { children }
    </div>
  )
}

export default TableRowSubMenu
